// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c1f3001802320bf0","7575":"8daf9a0b0422d8f1"}[chunkId] + ".css";
};